import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=00ee88ac&scoped=true&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewsAdd.vue?vue&type=style&index=0&id=00ee88ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ee88ac",
  null
  
)

export default component.exports